// extracted by css-extract-rspack-plugin
export default {"text":"text-e9DVfJ","icon":"icon-ijNd_t"};